<template>
    <div class="automation-block-editor sleep">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t("automation.contact") }}</div>
            <TiptapEditor :placeholder="$t('automation.contact')" v-model="clone.contactId" automation-mode />
        </div>
        <div v-for="(data, dataIndex) in clone.data || []">
            <div class="line"></div>
            <div class="data-header">
                <CustomPicker v-model="data.type" :items="methods" idKey="id" labelKey="label" :title="$t('automation.selectAction')" />
                <SupsisButton small danger @click="deleteData(dataIndex)" v-if="clone.data.length > 1"
                    ><i class="material-icons">delete</i></SupsisButton
                >
            </div>
            <div
                class="editor-row customize-editor-minimize data-items"
                v-for="(payload, payloadIndex) in data.payload || []"
            >
                <UpdateTag
                    :payload="payload"
                    :type="data.type"
                    style="margin: 10px 0"
                    :selectedType="getSelectedType(payload)"
                    v-if="data.type === 'addTag' || data.type === 'removeTag'"
                    :isDeleteButtonVisible="data.payload.length > 1"
                    @delete="deletePayloadItem(dataIndex, payloadIndex)"
                    @save="save($event, dataIndex, payloadIndex)"
                />
                <UpdateContactProperty
                    v-else-if="data.type === 'updateContactProperty'"
                    :payload="payload"
                    :type="data.type"
                    :properties="properties"
                    idKey="id"
                    labelKey="label"
                    title="Select Action"
                    :key="payloadIndex"
                    :isDeleteButtonVisible="data.payload.length > 1"
                    @save="save($event, dataIndex, payloadIndex)"
                    @delete="deletePayloadItem(dataIndex, payloadIndex)"
                    style="margin-top: 10px"
                />
                <UpdateInfo
                    v-else
                    :payload="payload"
                    :fields="fields"
                    idKey="id"
                    labelKey="label"
                    title="Select Action"
                    :key="dataIndex + payloadIndex"
                    :isDeleteButtonVisible="data.payload.length > 1"
                    @save="save($event, dataIndex, payloadIndex)"
                    @delete="deletePayloadItem(dataIndex, payloadIndex)"
                    style="margin-top: 10px"
                />
            </div>
            <SupsisButton xxsmall ghost @click="addPayloadItem(dataIndex)" v-if="isAddPayloadButtonVisible(data)">
                <span class="material-icons">add</span>
            </SupsisButton>
        </div>
        <SupsisButton small ghost @click="addDataItem" v-if="clone.data.length !== methods.length"
            >{{ $t("automation.addMethod") }}
        </SupsisButton>
        <div class="switch">
            <span class="label">{{ $t('auto.updateContactListenEvent') }}</span>
            <a-switch v-model="clone.isListenEvent" />
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";
import DataItem from "../webhook/DataItem.vue";
import UpdateInfo from "./UpdateInfo.vue";
import UpdateTag from "./UpdateTag.vue";
import TagPicker from "../../pickers/TagPicker.vue";
import { mapState } from "vuex";
import { getContactProperty } from "../../../../../../../api/contactProperty";
import UpdateContactProperty from "./UpdateContactProperty.vue";

const log = log2("UpdateContact");
export default {
    name: "UpdateContact",
    components: {
        TagPicker,
        DataItem,
        CustomPicker,
        SupsisButton,
        TiptapEditor,
        UpdateInfo,
        UpdateTag,
        UpdateContactProperty,
    },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            contactId: "",
            data: [
                {
                    type: "updateProfileInfo", // addTag, removeTag, updateContactProperty
                    payload: [
                        {
                            field: "name", // name,email,phone,platform
                            value: "",
                        },
                    ],
                },
            ],
            isListenEvent: false,
        };
        return {
            clone,
            methods: [
                {
                    id: "updateProfileInfo",
                    label: "Update Profile Info",
                },
                {
                    id: "addTag",
                    label: "Add Tag",
                },
                {
                    id: "removeTag",
                    label: "Remove Tag",
                },
                {
                    id: "updateContactProperty",
                    label: "Update Contact Property",
                },
            ],
            fields: [
                {
                    id: "fullname",
                    label: "fullname",
                },
                {
                    id: "email",
                    label: "email",
                },
                {
                    id: "phone",
                    label: "phone",
                },
            ],
            properties: [],
        };
    },
    computed: {
        ...mapState({
            tags: (state) => state.tag.tags.data,
        }),
    },
    methods: {
        getSelectedType(payload) {
            if (payload.value.includes("{{")) {
                return "dynamic";
            } else return "static";
        },
        isAddPayloadButtonVisible(data) {
            if (data.type === "updateProfileInfo") {
                return data.payload.length !== this.fields.length;
            } else if (["addTag", "removeTag"].includes(data.type)) {
                return data.payload.length !== this.tags.length;
            } else if (data.type === "updateContactProperty") {
                return data.payload.length !== this.properties.length;
            }
        },
        getActions(dataIndex) {
            let cloneActions = _.cloneDeep(this.methods);
            return this.clone.data.map((data) => {
                return {
                    id: data.type,
                    label: data.type,
                };
            });
            return cloneActions;
        },
        deleteData(dataIndex) {
            this.clone.data.splice(dataIndex, 1);
            this.clone = _.cloneDeep(this.clone);
            this.$nextTick(() => {});
        },
        deletePayloadItem(dataIndex, payloadIndex) {
            this.clone.data[dataIndex].payload.splice(payloadIndex, 1);
            this.clone = _.cloneDeep(this.clone);
            this.$nextTick(() => {});
        },
        save(event, dataIndex, payloadIndex) {
            console.log("event save..", event, dataIndex, payloadIndex, this.clone);
            this.clone.data[dataIndex].payload[payloadIndex] = event;
            this.clone = _.cloneDeep(this.clone);
        },
        addPayloadItem(dataIndex) {
            this.clone.data[dataIndex].payload.push({
                field: "",
                value: "",
            });
            this.clone = _.cloneDeep(this.clone);
            this.$nextTick(() => {});
        },
        addDataItem() {
            this.clone.data.push({
                type: "updateProfileInfo",
                payload: [
                    {
                        field: "name",
                        value: "",
                    },
                ],
            });
            this.clone = _.cloneDeep(this.clone);
            this.$nextTick(() => {});
        },
    },
    async mounted() {
        console.log("this.value..", this.value);
        await getContactProperty().then((res) => {
            res.data = res.data.map((item) => {
                return {
                    id: item._id,
                    label: item.label,
                };
            });
            console.log("this.properties..", res.data);
            this.properties = res.data;
        });
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                console.log("watch clone..", newValue);
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.line {
    border-bottom: 1px solid #acacac;
    margin-bottom: 10px;
}

.data-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.automation-block-editor.sleep {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .data-items {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .webhook-data-item {
            border-bottom: 1px solid var(--color-border-default);
            padding-bottom: 3px;
        }
    }

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }
}

.switch {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 20px;

    .label {
        font-weight: 500;
        font-size: 17px;
        margin-right: 10px;
    }
}
</style>
